import React from "react";
import {css} from "@emotion/react";

import {Card, CardCoverRatioVariants} from "@pg-design/card-module";
import {onDesktop} from "@pg-design/helpers-css";
import {numberFormat, pluralize} from "@pg-mono/string-utils";

import {useResponsiveLinkTarget} from "../../hooks/use_responsive_link_target";

export interface IInvestmentOfferTileProps {
    className?: string;
    href: string;
    offersCount: number;
    image: string;
    title: string;
    text?: string;
    ratioVariant: CardCoverRatioVariants;
}

const offersPlural = pluralize(["oferta", "oferty", "ofert"]);

export const InvestmentOfferTile = (props: IInvestmentOfferTileProps) => {
    const target = useResponsiveLinkTarget();

    return (
        <Card
            href={props.href}
            target={target}
            badge={`${numberFormat(props.offersCount)} ${offersPlural(props.offersCount)}`}
            className={props.className}
            css={investmentOfferTileWrapperStyle}
        >
            <Card.CoverImageWithText image={props.image} title={props.title} text={props.text} ratioVariant={props.ratioVariant} />
        </Card>
    );
};

const investmentOfferTileWrapperStyle = css`
    flex: 0 0 auto;

    ${onDesktop(css`
        flex: 0 1 auto;
    `)};
`;
import React from "react";
import {css} from "@emotion/react";

import {Card, CardCoverRatioVariants} from "@pg-design/card-module";
import {onDesktop} from "@pg-design/helpers-css";
import {numberFormat, pluralize} from "@pg-mono/string-utils";

import {useResponsiveLinkTarget} from "../../hooks/use_responsive_link_target";

export interface IInvestmentOfferTileProps {
    className?: string;
    href: string;
    offersCount: number;
    image: string;
    title: string;
    text?: string;
    ratioVariant: CardCoverRatioVariants;
}

const offersPlural = pluralize(["oferta", "oferty", "ofert"]);

export const InvestmentOfferTile = (props: IInvestmentOfferTileProps) => {
    const target = useResponsiveLinkTarget();

    return (
        <Card
            href={props.href}
            target={target}
            badge={`${numberFormat(props.offersCount)} ${offersPlural(props.offersCount)}`}
            className={props.className}
            css={investmentOfferTileWrapperStyle}
        >
            <Card.CoverImageWithText image={props.image} title={props.title} text={props.text} ratioVariant={props.ratioVariant} />
        </Card>
    );
};

const investmentOfferTileWrapperStyle = css`
    flex: 0 0 auto;

    ${onDesktop(css`
        flex: 0 1 auto;
    `)};
`;
